// src/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: "#FAF7F2", // Warm creamy off-white background
      paper: "#ffffff",   // Slightly deeper tone for cards & surfaces
    },
    primary: {
      main: "#4A3525",    // Deep espresso brown (primary buttons, key accents)
      light: "#6E5037",   // Warm mocha brown
      dark: "#2E1F14",    // Dark roasted coffee brown
      contrastText: "#FAF7F2",
    },
    secondary: {
      main: "#A67C52",    // Warm caramel / camel brown
      light: "#CBB399",   // Soft beige sand
      dark: "#7A5734",
      contrastText: "#FAF7F2",
    },
    text: {
      primary: "#2C2018",   // Soft deep brown (gentler and richer than pure black)
      secondary: "#7A685B", // Muted taupe/earthy gray
    },
    divider: "rgba(74, 53, 37, 0.12)", // Subtle brown border divider
  },

  typography: {
    fontFamily:
      '"Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h3: {
      fontWeight: 800,
      letterSpacing: "-0.04em",
      color: "#2C2018",
    },
    body1: {
      lineHeight: 1.6,
      color: "#7A685B",
    },
  },

  shape: {
    borderRadius: 18,
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#FAF7F2",
          color: "#2C2018",
          /* Hide scrollbar for Chrome, Safari, Edge */
          "&::-webkit-scrollbar": {
            display: "none",
          },
          /* Hide scrollbar for Firefox */
          scrollbarWidth: "none",
          /* Hide scrollbar for IE & older Edge */
          "-ms-overflow-style": "none",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          textTransform: "none",
          fontWeight: 600,
        },
        containedPrimary: {
          backgroundColor: "#4A3525",
          "&:hover": {
            backgroundColor: "#2E1F14",
          },
        },
        outlinedPrimary: {
          borderColor: "rgba(74, 53, 37, 0.3)",
          color: "#4A3525",
          "&:hover": {
            borderColor: "#4A3525",
            backgroundColor: "rgba(74, 53, 37, 0.04)",
          },
        },
      },
    },
  },
});

export default theme;